import { render, staticRenderFns } from "./FeaturetteItem.vue?vue&type=template&id=7718a58c&scoped=true"
import script from "./FeaturetteItem.vue?vue&type=script&lang=js"
export * from "./FeaturetteItem.vue?vue&type=script&lang=js"
import style0 from "./FeaturetteItem.vue?vue&type=style&index=0&id=7718a58c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7718a58c",
  null
  
)

export default component.exports